import { defineStore } from 'pinia';
import businessHours from './modules/businessHours';
import inboxes from './modules/inboxes';
import members from './modules/members';
import messageForm from './modules/message-form';
import messages from './modules/messages';
import number from './modules/number';
import subscriptions from './modules/subscriptions';
import unread from './modules/unread';
import Toast from './modules/toast';

import user from './modules/user';
import Form from './modules/form';
import Tags from './modules/tags';
import Notes from './modules/notes';
import ContactsByTag from './modules/contactsByTag';
import Clients from './modules/clients';
import Dropdown from './modules/dropdown';
import Contacts from './modules/contacts';
import ContactsMerge from './modules/contactsMerge';
import Triggers from './modules/triggers';
import AddFunds from './modules/add-funds';
import Broadcasts from './modules/broadcasts';
import RecurringBroadcasts from './modules/recurring-broadcasts';
import Shortcodes from './modules/shortcodes';
import KioskUsers from './modules/kiosk/users';
import Invitations from './modules/invitations';
import Integrations from './modules/integrations';
import Organization from './modules/organization';
import AutoRecharge from './modules/auto-recharge';
import Chat from './modules/chat';
import EarlyUpgrade from './modules/early-upgrade';
import CannedMessages from './modules/cannedmessages';
import ContactImports from './modules/contactImports';
import BillingSources from './modules/billing/sources';
import ScheduledMessages from './modules/scheduledmessages';
import ClientInvitations from './modules/client-invitations';
import KioskOrganizations from './modules/kiosk/organizations';
import Conversations from './modules/conversations';
import CustomFields from './modules/custom-fields';
import DLCProfile from './modules/dlc-profile';
import EmailToSms from './modules/email-to-sms';
import Aircall from './modules/aircall';
import FilterSegment from './modules/filterSegment';
import VoiceOrVideo from './modules/voice-or-video';
import Extension from './modules/extension';
import ComplianceProfile from './modules/compliance-profile';
import Webhooks from './modules/webhooks';
import AccessRequests from './modules/access-requests';
import Analytics from './modules/analytics';
import Keywords from './modules/keywords';
import Search from './modules/search';
import Slack from './modules/slack';
import Auth2f from './modules/auth-2f';
import Shortener from './modules/shortener';
import Intercom from './modules/intercom';
import Salesforce from './modules/salesforce';
import HubspotAttachments from './modules/hubspot-attachments';
import TextingAssistant from './modules/texting-assistant';
import VoiceAssistant from './modules/voice-assistant';
import { ConversationsModules } from 'views/Conversations/index.js';
import Segment from './modules/segment';
import TollFreeVerificationAi from './modules/toll-free-verification-ai';
import Hubspot from './modules/hubspot';
import Teams from './modules/teams';
import DataLogs from './modules/data-log';
import { TollFreeStore } from 'views/Settings/Organization/Settings/Compliance/TollFree';
import { CallingStore } from 'views/Settings/Organization/Settings/Compliance/Calling';

const modules = {
    BusinessHours: defineStore('businessHours', businessHours),
    Inboxes: defineStore('inboxes', inboxes),
    Members: defineStore('members', members),
    MessageForm: defineStore('messageForm', messageForm),
    Messages: defineStore('messages', messages),
    Number: defineStore('number', number),
    Subscriptions: defineStore('subscriptions', subscriptions),
    Unread: defineStore('unread', unread),
    User: defineStore('user', user),

    // TODO Refactor the following stores...
    Form: defineStore('Form', Form),
    Tags: defineStore('Tags', Tags),
    Notes: defineStore('Notes', Notes),
    ContactsByTag: defineStore('ContactsByTag', ContactsByTag),
    Toast: defineStore('Toast', Toast),
    Clients: defineStore('Clients', Clients),
    Dropdown: defineStore('Dropdown', Dropdown),
    Contacts: defineStore('Contacts', Contacts),
    ContactsMerge: defineStore('ContactsMerge', ContactsMerge),
    Triggers: defineStore('Triggers', Triggers),
    AddFunds: defineStore('AddFunds', AddFunds),
    Broadcasts: defineStore('Broadcasts', Broadcasts),
    RecurringBroadcasts: defineStore('RecurringBroadcasts', RecurringBroadcasts),
    Shortcodes: defineStore('Shortcodes', Shortcodes),
    KioskUsers: defineStore('KioskUsers', KioskUsers),
    Invitations: defineStore('Invitations', Invitations),
    Integrations: defineStore('Integrations', Integrations),
    Organization: defineStore('Organization', Organization),
    AutoRecharge: defineStore('AutoRecharge', AutoRecharge),
    Chat: defineStore('Chat', Chat),
    EarlyUpgrade: defineStore('EarlyUpgrade', EarlyUpgrade),
    CannedMessages: defineStore('CannedMessages', CannedMessages),
    ContactImports: defineStore('ContactImports', ContactImports),
    BillingSources: defineStore('BillingSources', BillingSources),
    ClientInvitations: defineStore('ClientInvitations', ClientInvitations),
    ScheduledMessages: defineStore('ScheduledMessages', ScheduledMessages),
    KioskOrganizations: defineStore('KioskOrganizations', KioskOrganizations),
    Conversations: defineStore('Conversations', Conversations),
    CustomFields: defineStore('CustomFields', CustomFields),
    DLCProfile: defineStore('DLCProfile', DLCProfile),
    Aircall: defineStore('Aircall', Aircall),
    FilterSegment: defineStore('FilterSegment', FilterSegment),
    VoiceOrVideo: defineStore('VoiceOrVideo', VoiceOrVideo),
    Extension: defineStore('Extension', Extension),
    ComplianceProfile: defineStore('ComplianceProfile', ComplianceProfile),
    Webhooks: defineStore('Webhooks', Webhooks),
    AccessRequests: defineStore('AccessRequests', AccessRequests),
    Analytics: defineStore('Analytics', Analytics),
    Keywords: defineStore('Keywords', Keywords),
    Search: defineStore('Search', Search),
    Slack: defineStore('Slack', Slack),
    EmailToSms: defineStore('EmailToSms', EmailToSms),
    Auth2f: defineStore('Auth2f', Auth2f),
    Shortener: defineStore('Shortener', Shortener),
    Intercom: defineStore('Intercom', Intercom),
    Salesforce: defineStore('Salesforce', Salesforce),
    HubspotAttachments: defineStore('HubspotAttachments', HubspotAttachments),
    TextingAssistant: defineStore('TextingAssistant', TextingAssistant),
    VoiceAssistant: defineStore('VoiceAssistant', VoiceAssistant),
    Segment: defineStore('Segment', Segment),
    ...ConversationsModules,
    TollFreeVerificationAi: defineStore('TollFreeVerificationAi', TollFreeVerificationAi),
    Hubspot: defineStore('Hubspot', Hubspot),
    Teams: defineStore('Teams', Teams),
    DataLogs: defineStore('DataLogs', DataLogs),

    TollFreeStore: defineStore('TollFreeStore', TollFreeStore),
    CallingStore: defineStore('CallingStore', CallingStore),
};

// Core Stores
export const useUserStore = modules.User;
export const useOrganizationStore = modules.Organization;
export const useSubscriptionsStore = modules.Subscriptions;
export const useNumberStore = modules.Number;
export const useBusinessHoursStore = modules.BusinessHours;
export const useInboxesStore = modules.Inboxes;
export const useMembersStore = modules.Members;
export const useMessageFormStore = modules.MessageForm;
export const useMessagesStore = modules.Messages;
export const useUnreadStore = modules.Unread;

// UI & Form Stores
export const useFormStore = modules.Form;
export const useToastStore = modules.Toast;
export const useDropdownStore = modules.Dropdown;

// Contact & Communication Stores
export const useContactsStore = modules.Contacts;
export const useContactsByTagStore = modules.ContactsByTag;
export const useContactsMergeStore = modules.ContactsMerge;
export const useContactImportsStore = modules.ContactImports;
export const useTagsStore = modules.Tags;
export const useNotesStore = modules.Notes;
export const useConversationsStore = modules.Conversations;
export const useCannedMessagesStore = modules.CannedMessages;
export const useScheduledMessagesStore = modules.ScheduledMessages;

// Messaging & Broadcasting
export const useBroadcastsStore = modules.Broadcasts;
export const useRecurringBroadcastsStore = modules.RecurringBroadcasts;
export const useTriggersStore = modules.Triggers;
export const useShortcodesStore = modules.Shortcodes;
export const useTextingAssistantStore = modules.TextingAssistant;
export const useVoiceAssistantStore = modules.VoiceAssistant;

// Integrations
export const useIntegrationsStore = modules.Integrations;
export const useHubspotStore = modules.Hubspot;
export const useHubspotAttachmentsStore = modules.HubspotAttachments;
export const useSalesforceStore = modules.Salesforce;
export const useSlackStore = modules.Slack;
export const useIntercomStore = modules.Intercom;
export const useAircallStore = modules.Aircall;

// Billing & Commerce
export const useBillingSourcesStore = modules.BillingSources;
export const useAddFundsStore = modules.AddFunds;
export const useAutoRechargeStore = modules.AutoRecharge;
export const useEarlyUpgradeStore = modules.EarlyUpgrade;

// Analytics & Reporting
export const useAnalyticsStore = modules.Analytics;
export const useDataLogsStore = modules.DataLogs;
export const useSearchStore = modules.Search;
export const useSegmentStore = modules.Segment;
export const useFilterSegmentStore = modules.FilterSegment;

// Client & Team Management
export const useClientsStore = modules.Clients;
export const useClientInvitationsStore = modules.ClientInvitations;
export const useTeamsStore = modules.Teams;
export const useInvitationsStore = modules.Invitations;
export const useAccessRequestsStore = modules.AccessRequests;
export const useKioskUsersStore = modules.KioskUsers;
export const useKioskOrganizationsStore = modules.KioskOrganizations;

// Compliance & Security
export const useComplianceProfileStore = modules.ComplianceProfile;
export const useDLCProfileStore = modules.DLCProfile;
export const useTollFreeVerificationAiStore = modules.TollFreeVerificationAi;
export const useAuth2fStore = modules.Auth2f;
export const useTollFreeStoreStore = modules.TollFreeStore;
export const useCallingStoreStore = modules.CallingStore;

// Features & Tools
export const useWebhooksStore = modules.Webhooks;
export const useKeywordsStore = modules.Keywords;
export const useShortenerStore = modules.Shortener;
export const useCustomFieldsStore = modules.CustomFields;
export const useChatStore = modules.Chat;
export const useExtensionStore = modules.Extension;
export const useVoiceOrVideoStore = modules.VoiceOrVideo;
export const useEmailToSmsStore = modules.EmailToSms;

export default modules;
